import BottomNavigationBar from './BottomNavigationBar';

export default BottomNavigationBar;
